<template>
  <m-card316 :image="content.thumbnail" :alt="content.alt">
      <template #front>
        <h5>{{ content.title }}</h5>
      </template>

    <template #back>
      <div class="word-wrap">
        <p v-html="content.abstraction"></p>
      </div>
    </template>
  </m-card316>
</template>

<script>

import mIcon from "../../Icons/Icon.vue";
import mA from "../../Tags/A.vue";
import mH5 from "../../Tags/H5.vue";
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";
import mCard316 from "../../Cards/Card316";

export default {
  name: "ContentCard310.vue",
  methods: {contentSlicer},
  props: {
    content: {}
  },
  components: {mH5, mA, mIcon, mCard316, }

}
</script>

<style scoped>
.word-wrap{
  word-break: break-word;
}
</style>